import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-stage-deep water-glow-soft py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-121" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-122" data-mp="1dybdoouuox3b">
        <div className="text-center" data-id="element-123" data-mp="2bjz1wmh5k93r">
          <span className="metal-surface inline-flex items-center gap-2 rounded-md px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-navyDeep" data-id="element-124" data-mp="2bixjty1pymcj">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-125" data-mp="21ljil5oda44t" /> Complete classroom coverage
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-126" data-mp="1wnrdtb2minj7">
            The {totalVolumes} comprehensive volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-127" data-mp="l82q2hhjpkhc">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-silverEdge bg-navy shadow-card" data-id="element-128" data-mp="1it5ramcagnmk" data-mpi={index}>
                <div className="flex items-center gap-4 border-b border-silverEdge bg-navyPanel px-6 py-5" data-id="element-129" data-mp="14vpk38m64ptr">
                  <span className="metal-surface flex h-12 w-12 shrink-0 items-center justify-center rounded-md text-navyDeep" data-id="element-130" data-mp="q7mei0c1fg5h">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-131" data-mp="v5xocb2c1qnp" />
                  </span>
                  <div data-id="element-132" data-mp="h6eqqc75dxpn">
                    <p className="text-[11px] font-extrabold uppercase tracking-[.18em] text-silver" data-id="element-133" data-mp="h891ixopg9g0">
                      Volume {module.number}
                    </p>
                    <h3 className="mt-1 text-lg font-extrabold leading-tight text-white" data-id="element-134" data-mp="2nvq7q295xs02">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-135" data-mp="2e42k6cfq8v3v">
                  <p className="font-semibold text-silverBright" data-id="element-136" data-mp="2e4lvvbesan9g">{module.subtitle}</p>

                  <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[.16em] text-silverDark" data-id="element-137" data-mp="296u2se2ekv3o">
                    What does it solve in the classroom?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-silver" data-id="element-138" data-mp="31v7z8pdufjd4">{module.context}</p>

                  <ul className="mt-5 grid flex-1 gap-2" data-id="element-139" data-mp="2wtio79qmf5p1">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-silverBright" data-id="element-140" data-mp="2ssp0agd6hqw5">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-silver" aria-hidden="true" data-id="element-141" data-mp="1lh821m6du7tk" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-silver bg-white/5 p-4 text-sm leading-relaxed text-silverBright" data-id="element-142" data-mp="3t39lui8uasjx">
                    <b className="font-extrabold text-white" data-id="element-143" data-mp="5wpd4u908fz8">Result: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl border border-silverEdge bg-navyPanel px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-144" data-mp="fn1vcftcjx27">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-silver" data-id="element-145" data-mp="on716liw6ne9">Main collection</p>
          <p className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-146" data-mp="tm1jlmcy69xu">
            {totalVolumes} premium volumes <span className="mx-2 text-silver" data-id="element-147" data-mp="2qfd3hkxxi8fs">·</span> Updated for 2026
          </p>
        </div>
      </div>
    </section>;
}